import React from 'react';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

export const GlobalApiAuthenticationFailed = () => (
  <div className="space-y-f2 text-md w-1/3">
    <span>Failed to authenticate user</span>
    <p>
      This is most likely our fault. If the problem persists, please contact{' '}
      <a
        href="mailto:help@fragment.dev"
        className="hover:cursor-pointer decoration-main-500 hover:decoration-main underline transition-all duration-150 ease-in-out"
      >
        support
      </a>
      .
    </p>
  </div>
);

export const PodApiAuthenticationFailed = () => {
  const location = window.location.host;
  const message = location.includes('localhost') ? (
    <p className="text-orange">
      Hey Friend - If you&apos;re in development mode, this issue may occur due
      to the use of an incognito browser. Authentication could fail due to third
      party cookies being blocked.
    </p>
  ) : (
    <div />
  );
  return (
    <div className="space-y-f2 text-md w-1/3">
      <span>Failed to authenticate workspace</span>
      <p>
        This is most likely our fault. Try switching to other workspaces. If the
        problem persists, please contact{' '}
        <a
          href="mailto:help@fragment.dev"
          className="hover:cursor-pointer decoration-main-500 hover:decoration-main underline transition-all duration-150 ease-in-out"
        >
          support
        </a>
        .
      </p>
      {message}
      <PrimaryButtonV2 onClick={() => window.location.reload()}>
        Refresh
      </PrimaryButtonV2>
    </div>
  );
};
